import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-48aea97f")

_pushScopeId("data-v-48aea97f")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "title" }, "评论", -1)
const _hoisted_2 = {
  key: 0,
  class: "title"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_editor = _resolveComponent("editor")
  const _component_commentOne = _resolveComponent("commentOne")
  const _component_pagination = _resolveComponent("pagination")
  const _component_toast = _resolveComponent("toast")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_editor, {
      csrf: _ctx.csrf,
      post_id: _ctx.post_id,
      onUplist: _ctx.uplist
    }, null, 8, ["csrf", "post_id", "onUplist"]),
    (_ctx.comment.length >= 1)
      ? (_openBlock(), _createBlock("div", _hoisted_2, "相关评论"))
      : _createCommentVNode("", true),
    _createVNode(_component_commentOne, {
      csrf: _ctx.csrf,
      post_id: _ctx.post_id,
      comment: _ctx.comment,
      onGetlist: _ctx.getList
    }, null, 8, ["csrf", "post_id", "comment", "onGetlist"]),
    _createVNode(_component_pagination, {
      currentPage: _ctx.page,
      limit: _ctx.limit,
      totalCount: _ctx.total,
      onTurn: _ctx.getList
    }, null, 8, ["currentPage", "limit", "totalCount", "onTurn"]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ]))
})